import React, { Fragment, useState, useEffect } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Home from './screens/home';
import { routes } from './routes/index';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/app.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ScrollToTop from './helper/scrollToTop';

const App = () => {
    const [showScroll, setShowScroll] = useState(false);

    const checkScrollTop = () => {
        if (window.pageYOffset > 500) {
            setShowScroll(true);
        } else {
            setShowScroll(false);
        }
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop);
        return () => window.removeEventListener('scroll', checkScrollTop);
    }, []);

    return (
        <Fragment>
            <BrowserRouter basename={`/`}>
                <ScrollToTop />
                <Home>
                    <Route
                        exact
                        path={'/'}
                        render={() => {
                            return <Redirect to="/homepage" />;
                        }}
                    />
                    <TransitionGroup>
                        <CSSTransition timeout={0} unmountOnExit>
                            <Switch>
                                {routes.map(({ path, Component }) => (
                                    <Route key={path} exact path={`${path}`}>
                                        {() => <Component />}
                                    </Route>
                                ))}
                            </Switch>
                        </CSSTransition>
                    </TransitionGroup>
                </Home>
            </BrowserRouter>
            <button
                type="button"
                className={`rounded-circle scroll-top_btn shadow`}
                style={{
                    display: showScroll ? 'inline' : 'none',
                }}
                onClick={scrollTop}
            >
                ↑
            </button>
            <ToastContainer />
        </Fragment>
    );
};

export default App;
